import { Route, Routes } from 'react-router-dom';
import AuthGuard from '@/guards/AuthGuard';
import RoleBasedGuard from '@/guards/RoleBasedGuard';
import DashboardLayout from '@/layouts/dashboard';
import { ReferralDetails, ReferralsList } from '../pages';
import { PATH_REFERRALS } from './paths';

const REFERRAL_ROUTES = [
  {
    path: PATH_REFERRALS.list,
    roles: ['referrals.view'],
    component: <ReferralsList />,
    index: true,
  },
  {
    path: PATH_REFERRALS.detail,
    roles: ['referrals.view'],
    component: <ReferralDetails />,
    index: false,
  },
];

export const ReferralsRoutes = () => (
  <Routes>
    <Route
      element={
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      }
    >
      {REFERRAL_ROUTES.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          index={route.index}
          element={
            <RoleBasedGuard roles={route.roles}>
              {route.component}
            </RoleBasedGuard>
          }
        />
      ))}
    </Route>
  </Routes>
);
